"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createMicrophoneButtonStyle;

function createMicrophoneButtonStyle(_ref) {
  var microphoneButtonColorOnDictate = _ref.microphoneButtonColorOnDictate;
  return {
    // TODO: [P3] This path should not know anything about the DOM tree of <IconButton>
    '&.dictating > button': {
      '&, &:focus, &:hover': {
        '& svg': {
          fill: microphoneButtonColorOnDictate
        }
      }
    }
  };
}